import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class FadeOut extends XYEffect {
	static key = "FadeOut";
	private blankTimer: number;
	private blackTimer: number;

	constructor(xy: XY, blankTimer: number, blackTimer: number) {
		super(xy);
		this.blankTimer = blankTimer;
		this.blackTimer = blackTimer;
	}

	getBlankTimer(): number {
		return this.blankTimer;
	}

	getBlackTimer(): number {
		return this.blackTimer;
	}
}
